var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassportFrontPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 171 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h171v108H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.942 107.983c.125.011.251.017.378.017h2.622v-1.2H4.32c-.092 0-.184-.004-.274-.012l-.104 1.195Zm9 .017v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm5.999 0v-1.2h-2.999v1.2h2.999Zm6.001 0v-1.2h-3v1.2h3Zm5.999 0v-1.2h-2.999v1.2h2.999Zm3 0h3.001v-1.2h-3.001v1.2Zm9.001 0v-1.2h-3.001v1.2h3.001Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm5.999 0v-1.2h-2.999v1.2h2.999Zm6 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm6.001 0v-1.2h-3v1.2h3Zm3 0h3v-1.2h-3v1.2Zm9 0v-1.2h-3v1.2h3Zm6 0v-1.2h-3v1.2h3Zm5.897-.578-.601-1.039a3.104 3.104 0 0 1-1.558.417l.064.002-.072-.002h-.73v1.2h.738c.207 0 .41-.015.609-.043.158-.504.165-.998-.335-1.125a1.2 1.2 0 0 1 .914 1.002c.343-.098.669-.237.971-.412ZM.019 104.087a4.31 4.31 0 0 0 1.257 2.657l.846-.851a3.107 3.107 0 0 1-.908-1.918l-1.195.112ZM171 102.205h-1.2v1.475c0 .379-.067.742-.191 1.078l1.125.415c.172-.465.266-.968.266-1.493v-1.475ZM0 98.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 92.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 86.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 80.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 74.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 68.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 62.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 56.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 50.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 44.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 38.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 32.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 26.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 20.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 14.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM0 8.088v3h1.2v-3H0Zm171-1.883h-1.2v3h1.2v-3ZM.564 2.186A4.296 4.296 0 0 0 0 4.32v.768h.237C.098 5.331 0 5.52 0 5.52l.432-.432H1.2V4.32c0-.56.147-1.085.406-1.54L.564 2.186Zm169.619-.393-.972.703c.371.513.589 1.143.589 1.824h1.2c0-.943-.303-1.816-.817-2.527ZM5.766 0H4.32c-.535 0-1.048.098-1.521.276l.423 1.123A3.104 3.104 0 0 1 4.32 1.2h1.446V0Zm159 0v1.2h1.914c.268 0 .528.034.777.097l.298-1.162A4.332 4.332 0 0 0 166.68 0h-1.914Zm-147 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm-12 0h-3v1.2h3V0Zm24 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm12 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm6 0h-3v1.2h3V0Zm-78 0h-3v1.2h3V0Zm-54 0h-3v1.2h3V0Z",
    style: {
      fill: "#061437",
      fillOpacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.106,
    cy: 54.432,
    r: 27.476,
    style: {
      fill: "#061437",
      fillOpacity: 0.12
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.106,
    cy: 54.432,
    r: 27.476
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.106,
    cy: 48.064,
    r: 12.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.106,
    cy: 84.683,
    r: 21.787,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.915 24.635c0-.851-.691-1.543-1.543-1.543H82.779c-.852 0-1.543.692-1.543 1.543v4.642c0 .851.691 1.543 1.543 1.543h59.593c.852 0 1.543-.692 1.543-1.543v-4.642ZM111.061 66.34c0-.852-.692-1.543-1.543-1.543H82.779c-.852 0-1.543.691-1.543 1.543v1.33c0 .851.691 1.542 1.543 1.542h26.739c.851 0 1.543-.691 1.543-1.542v-1.33Zm40.955 0c0-.852-.691-1.543-1.543-1.543h-26.739c-.852 0-1.543.691-1.543 1.543v1.33c0 .851.691 1.542 1.543 1.542h26.739c.852 0 1.543-.691 1.543-1.542v-1.33Z",
    style: {
      fill: "#061437",
      fillOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.37 39.232c0-.852-.691-1.543-1.543-1.543H82.779c-.852 0-1.543.691-1.543 1.543v4.642c0 .851.691 1.542 1.543 1.542h75.048c.852 0 1.543-.691 1.543-1.542v-4.642ZM118.415 74.68c0-.851-.691-1.542-1.543-1.542H82.779c-.852 0-1.543.691-1.543 1.542v1.33c0 .852.691 1.543 1.543 1.543h34.093c.852 0 1.543-.691 1.543-1.543v-1.33Zm40.955 0c0-.851-.691-1.542-1.543-1.542h-34.093c-.852 0-1.543.691-1.543 1.542v1.33c0 .852.691 1.543 1.543 1.543h34.093c.852 0 1.543-.691 1.543-1.543v-1.33Z",
    style: {
      fill: "#061437",
      fillOpacity: 0.08
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassportFrontPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/passport-front-placeholder.8585547488969455fa37328d7dda66e8.svg";